/** @format */
import {
  DELETECallHelper,
  GETCallHelper,
  POSTCallHelper,
} from "../../services";
import { handleError } from "../../errorServices";
import Swal from "sweetalert2";
import Router from "../../../../router/router.js";

// Helper function for 403 access denied error
const handleAccessDenied = () => {
  Swal.fire({
    title: "Access Denied",
    text: "You don't have permission to access this resource.",
    icon: "error",
    confirmButtonText: "OK",
    confirmButtonColor: "rgba(0, 164, 153, 1)",
  }).then(() => {
    Router.go();
  });
};

export default {
  async fetchAllMedicalLetters() {
    try {
      let url = `/mo/medical-letters/fetch-medical-letters`;
      const response = await GETCallHelper(url);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      return response?.data?.data;
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        handleError(e.response.data);
      }
    }
  },

  async fetchMedicalLettersRequests({ commit }, payload) {
    try {
      let url = `/mo/medical-letters?status=${payload.status}&page=${
        payload.page
      }${
        payload?.medicalLetter ? `&medical_letter=${payload.medicalLetter}` : ""
      }${payload?.date ? `&date=${payload.date}` : ""}${
        payload?.search ? `&search=${payload.search}` : ""
      }`;
      const response = await GETCallHelper(url);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      commit("setMedicalLettersRequests", response?.data?.data);
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        handleError(e.response.data);
      }
    }
  },

  async fetchMedicalLetterRequest({ commit }, payload) {
    try {
      let url = `/mo/medical-letters/medical-letter-request?medical_letter_request=${payload.letterId}`;
      const response = await GETCallHelper(url);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      commit("setMedicalLetterRequest", response?.data);
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        handleError(e.response.data);
      }
    }
  },
  async fetchMedicalLetterRequestQuestions({ commit }, payload) {
    try {
      let url = `/mo/medical-letters/fetch-question-answers?medical_letter_request=${payload.letterRequestId}&medical_letter=${payload.letterId}`;
      const response = await GETCallHelper(url);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      commit("setMedicalLetterRequestQuestions", response?.data);
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        handleError(e.response.data);
      }
    }
  },

  async createSignature({ commit }, payload) {
    try {
      let url = "/mo/medical-letters/create-signature";
      const response = await POSTCallHelper(url, payload);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      commit("updateSignature", response?.data?.data);
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        handleError(e);
      }
    }
  },
  async fetchSignature({ commit }, payload) {
    try {
      let url = "/mo/medical-letters/fetch-medical-letter-signatures";
      const response = await GETCallHelper(url, payload);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      commit("setSignature", response?.data?.data);
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        handleError(e);
      }
    }
  },
  async deleteSignature(_, payload) {
    try {
      let url =
        "/mo/medical-letters/delete-medical-letter-signature?medical_letter_signature=";
      const response = await DELETECallHelper(url, payload);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        handleError(e);
      }
    }
  },
  async editSignature({ commit }, payload) {
    try {
      let url = `/mo/medical-letters/update-signature?medical_letter_signature=${payload?.signature?.signatureId}`;
      const response = await POSTCallHelper(url, payload.formdata);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      commit("editSignature", {
        response: response?.data?.data,
        signatureId: payload?.signature?.index,
      });
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        handleError(e);
      }
    }
  },

  async approvedMedicalLetterRequest(_, payload) {
    try {
      let url = `/mo/medical-letters/mo-notes`;
      const response = await POSTCallHelper(url, payload);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        handleError(e);
      }
    }
  },

  async createDoctorProfile({ commit }, payload) {
    try {
      let url = "/health_reports_manager/medical-letters/create-doctor-profile";
      await POSTCallHelper(url, payload);
    } catch (e) {
      if (e.response && e.response.status === 422) {
        commit(
          "setEmailError",
          "Email is already in use, please use another email."
        );
      }
      handleError(e);
    }
  },
  async fetchDoctorsProfile({ commit }, payload) {
    try {
      let url = `/health_reports_manager/medical-letters/fetch-doctor-profiles?${
        payload?.page ? `page=${payload.page}` : ""
      }${payload?.search ? `&search=${payload.search}` : ""}`;
      const response = await GETCallHelper(url);
      commit("setDoctorsProfile", response.data);
    } catch (e) {
      handleError(e);
    }
  },
  async fetchDoctorProfile({ commit }, payload) {
    try {
      let url = `/health_reports_manager/medical-letters/doctor-profile?doctor=${payload.doctorId}`;
      const response = await GETCallHelper(url);
      commit("setDoctorProfile", response.data.data);
    } catch (e) {
      handleError(e);
    }
  },
  async updateDoctorProfile(_, payload) {
    try {
      let url = "/health_reports_manager/medical-letters/update-doctor-profile";
      await POSTCallHelper(url, payload);
    } catch (e) {
      handleError(e);
    }
  },
  async fetchDoctorsProfileMO() {
    try {
      let url = `/mo/medical-letters/fetch-doctor-profiles`;
      const response = await GETCallHelper(url);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      return response?.data?.data;
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        handleError(e);
      }
    }
  },

  /***
   * FOR DOCTOR
   */

  async createSignatureByDoctor({ commit }, payload) {
    try {
      let url = "/doctor/medical-letters/create-signature";
      const response = await POSTCallHelper(url, payload);
      commit("updateSignatureDoctor", response?.data?.data);
    } catch (e) {
      handleError(e);
    }
  },
  async fetchSignatureByDoctor({ commit }) {
    try {
      console.log("about to fetch doctr ");
      let url = "/doctor/medical-letters/fetch-medical-letter-signatures";
      const response = await GETCallHelper(url);
      commit("setSignatureDoctor", response?.data?.data);
    } catch (e) {
      handleError(e);
    }
  },
  async deleteSignatureByDoctor({ commit }) {
    try {
      let url = "/doctor/medical-letters/delete-medical-letter-signature";
      commit("deleteSignatureDoctor");
      await DELETECallHelper(url);
    } catch (e) {
      handleError(e);
    }
  },
  async editSignatureByDoctor({ commit }, payload) {
    try {
      let url = `/doctor/medical-letters/update-signature`;
      const response = await POSTCallHelper(url, payload);

      commit("editSignatureDoctor", response?.data?.data?.doctor_signature);
    } catch (e) {
      handleError(e);
    }
  },

  async fetchMedicalLettersRequestsByDoctor({ commit }, payload) {
    try {
      let url = `/doctor/medical-letters?status=${payload.status}&page=${
        payload.page
      }${
        payload?.medicalLetter ? `&medical_letter=${payload.medicalLetter}` : ""
      }${payload?.date ? `&date=${payload.date}` : ""}${
        payload?.search ? `&search=${payload.search}` : ""
      }`;
      const response = await GETCallHelper(url);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      commit("setMedicalLettersRequests", response?.data?.data);
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        // Handle other errors without throwing
        console.log("Other error:", e);
      }
    }
  },

  async fetchMedicalLetterRequestByDoctor({ commit }, payload) {
    try {
      let url = `/doctor/medical-letters/medical-letter-request?medical_letter_request=${payload.letterId}`;
      const response = await GETCallHelper(url);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      commit("setMedicalLetterRequest", response?.data);
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        // Handle other errors without throwing
        console.log("Other error:", e);
      }
    }
  },

  async fetchMedicalLetterRequestQuestionsByDoctor({ commit }, payload) {
    try {
      let url = `/doctor/medical-letters/fetch-question-answers?medical_letter_request=${payload.letterRequestId}&medical_letter=${payload.letterId}`;
      const response = await GETCallHelper(url);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      commit("setMedicalLetterRequestQuestions", response?.data);
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        // Handle other errors without throwing
        console.log("Other error:", e);
      }
    }
  },

  async sendMedicalLetter(_, payload) {
    try {
      let url = `/doctor/medical-letters/send-medical-letter`;
      const response = await POSTCallHelper(url, payload);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }

      return response?.data?.data;
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        // Handle other errors without throwing
        console.log("Other error:", e);
      }
    }
  },
  async rejectMedicalLetterRequest(_, payload) {
    try {
      let url = `/doctor/medical-letters/reject`;
      const response = await POSTCallHelper(url, payload);

      // Check if response contains 403 error
      if (
        response &&
        response
          .toString()
          .includes("Error: Request failed with status code 403")
      ) {
        handleAccessDenied();
        return;
      }
    } catch (e) {
      if (e.response && e.response.status === 403) {
        handleAccessDenied();
      } else {
        // Handle other errors without throwing
        console.log("Other error:", e);
      }
    }
  },

  async fetchDoctor({ commit }) {
    try {
      let url = `/doctor/medical-letters/doctor-profile`;
      const response = await GETCallHelper(url);
      commit("setDoctor", response.data.data);
    } catch (e) {
      handleError(e);
    }
  },

  async loadPractices({ commit }) {
    try {
      const response = await GETCallHelper("practices/general-practices");
      commit("setPractices", response.data.practices);
      return response.data.practices;
    } catch (e) {
      handleError(e.response.data);
    }
  },
};
